<template>
  <el-form ref="baseForm" :rules="rules" :model="fromData">
    <search-box @subSearch="subSearch" :fromData="fromData">
      <el-form-item class="item" label="入库单号：" prop="materailVoucherNo">
        <el-input
          v-model="fromData.searchCriteria.materailVoucherNo"
          :placeholder="$store.state.remark.materailVoucherNo"
        ></el-input>
      </el-form-item>
      <el-form-item class="item" label="物料信息：" prop="codeOrDesc">
        <el-input
          v-model="fromData.searchCriteria.codeOrDesc"
          placeholder="物料编码、物料描述"
        ></el-input>
      </el-form-item>
      <el-form-item class="item time-between" label="选择日期：" prop="searchTime">
        <el-date-picker
          v-model="searchTime"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
    </search-box>
  </el-form>
</template>

<script>
import { suplierApi } from "api/base.js";
import searchBox from "components/common/search.vue";
export default {
  props: {
    fromData: Object
  },
  components: {
    searchBox
  },
  data() {
    return {
      rules: {
        materailVoucherNo: [{ message: "", trigger: "blur" }],
        codeOrDesc: [{ message: "", trigger: "change" }]
      },
      //供应商列表
      suplierList: [],
      //已选的供应商
      suplierListRes: {},
      getAllPage: {
        page: 1,
        pageSize: 10000
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      searchTime: ""
    };
  },
  created() {
    //设置默认日期最近一个月
    const startTime = new Date().getTime() - 3600 * 1000 * 24 * 30;
    const endTime = new Date();
    this.searchTime = [startTime, endTime];
    this.getStartData();
  },
  methods: {
    subSearch() {
      let timeArr = this.searchTime;
      if (timeArr != null) {
        let stime = this.$moment(timeArr[0]).format("YYYY-MM-DD");
        let etime = this.$moment(timeArr[1]).format("YYYY-MM-DD");
        this.fromData.searchCriteria.startDate = stime;
        this.fromData.searchCriteria.endDate = etime;
      }
      this.$emit("subSearch");
    },
    //初始化数据
    async getStartData() {
      //供应商
      let suplierList = await this.$post(suplierApi.list, this.getAllPage);
      if (!suplierList.status) {
        return false;
      } else {
        this.suplierList = suplierList.data.list;
        this.suplierList.forEach(item => {
          item.value = item.supplierCode + " " + item.supplierName;
        });
      }
    },
    //检索供应商
    querySearchAsync(queryString, cb) {
      var restaurants = this.suplierList;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      this.suplierListRes = results;
      /* console.log(results);
			this.timeout = setTimeout(() => {
			}, 1000 * Math.random()); */
      cb(results);
    },
    createStateFilter(queryString) {
      return state => {
        if (state.value) {
          return (
            state.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1
          );
        }
      };
    },
    //输入供应商
    enterHandleSelect() {
      if (this.suplierListRes.length) {
        let item = this.suplierListRes[0];
        this.handleSelect(item);
      } else {
        this.$message.error("没有此供应商");
        this.fromData.supplierDesc = "";
      }
    },
    //供应商选择后
    handleSelect(item) {
      /* this.fromData.supplierName = item.supplierName;
			this.fromData.supplierId = item.supplierId;
			this.fromData.supplierCode = item.supplierCode;		 */
    }
  }
};
</script>

<style>
</style>
